/* eslint-disable */

/**
 * Set up intial 'React.render()' into the DOM.
 */
// bootstrap the app with 8ball-wide stuff...
import '../bootstrap'
import { setup } from '../bootstrap'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import theStore from './stores/configureStore'
import theHistory from './stores/configureHistory'
import logger from 'loglevel'

const transferContainer = document.getElementById('react-transfer-container')

const render = (Component, store, history) => {
  if (transferContainer) {
    ReactDOM.render(
      <Component store={store} history={history} />,
      transferContainer
    )
  }
}

setup()
  .then(() => {
    render(App, theStore, theHistory)
  })
  .catch(err => logger.error(err))
